var map = {
	"./en/admin.json": "579b",
	"./en/dashboard.json": "ace8",
	"./en/main.json": "3f69",
	"./en/notification.json": "43f6",
	"./en/survey_plan_form.json": "ffd6",
	"./en/templatesubmission.json": "043d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";